__turbopack_context__.v({
  "dropdownNav": "Dropdown-module__sjfiSa__dropdownNav",
});
